import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusUniversitiesApi = createApi({
  reducerPath: 'erasmusUniversitiesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusUniversities: builder.query({
      query: (active = null) => {
        const params = {};
        if (active !== null) {
          params.active = active ? 'true' : 'false';
        }
        return {
          url: urls.erasmusUniversities,
          method: 'GET',
          params,
        };
      },
    }),
    getErasmusUniversity: builder.query({
      query: (id) => ({
        url: urls.erasmusUniversityDetail(id),
      }),
    }),
    getUniversitiesByIds: builder.query({
      query: (uniIds) => ({
        url: urls.universitiesStack,
        method: 'GET',
        params: { uniIds: uniIds.join(',') },
      }),
    }),
    saveErasmusUniversity: builder.mutation({
      query(req) {
        const data = {
          ...req.body,
          active: req.body.active ? '1' : '0',
        };
        let packedData = new FormData();

        Object.keys(data).forEach((key) => {
          let dataValue = data[key];

          if (dataValue !== undefined && dataValue !== null) {
            packedData.append(key, dataValue);
          }
        });

        if (req.id) {
          packedData.append('_method', 'put');
          return {
            url: urls.erasmusUniversityDetail(req.id),
            method: 'POST',
            data: packedData,
          };
        } else {
          return {
            url: urls.erasmusUniversities,
            method: 'POST',
            data: packedData,
          };
        }
      },
    }),
    deleteErasmusUniversity: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusUniversityDetail(id),
          method: 'DELETE',
        };
      },
    }),
    generateErasmusUniversitiesExcel: builder.mutation({
      query(req) {
        return {
          url: urls.erasmusUniversitiesExcel,
          method: 'POST',
          data: req.body,
        };
      },
    }),
  }),
});

export const {
  useGetErasmusUniversitiesQuery,
  useGetErasmusUniversityQuery,
  useGetUniversitiesByIdsQuery,
  useSaveErasmusUniversityMutation,
  useDeleteErasmusUniversityMutation,
  useGenerateErasmusUniversitiesExcelMutation,
} = erasmusUniversitiesApi;
